export const DebtTypes = {
    SHOW_TYPE: "SHOW_TYPE",
    ADD_TYPE: "ADD_TYPE",
    UPDATE_TYPE: "UPDATE_TYPE",
    DELETE_TYPE: "DELETE_TYPE",

}